import React, { useState, createContext, useContext, Dispatch, SetStateAction } from 'react';
import { TablesAndFloorPlansQuery_venue_floorPlans_tables as TableType } from '../__queries__';

// This type is used when creating a "fake" table for POS. Only the ID is ensured.
type POSTable = Partial<TableType> & { id: string };
type TableValue = TableType | POSTable | null;

interface ContextType {
  selectedTable: TableValue;
  setSelectedTable: Dispatch<SetStateAction<TableValue>>;
}

export interface MockedTableContextProps {
  selectedTable: TableValue;
}

interface ProviderProps {
  children: React.ReactNode;
  initialTable?: TableValue;
}

const Context = createContext<ContextType>({} as ContextType);

export default function TableContextProvider({ initialTable, children }: ProviderProps) {
  const [selectedTable, setSelectedTable] = useState<TableValue>(initialTable || null);

  const contextValue = {
    selectedTable,
    setSelectedTable,
  };

  return <Context.Provider value={contextValue}>{children}</Context.Provider>;
}

export const useTableContext = () => {
  const value = useContext(Context);

  if (!value.setSelectedTable) {
    throw new Error('Missing Provider for TableContext');
  }

  return value;
};
